import { getAddress } from "viem"

export const vaults = new Map([
  [
    getAddress("0x240FcAFffF24AAa39e420B6F70ED5519847648b4"),
    {
      name: "Isolated WBTC-AUSD AUSD",
      description:
        "A risk-isolated AUSD vault in the Euler Risk Isolated WBTC-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x8f47D9D9d5A8202a5a37c4E41fbDd3146D88A579"),
    {
      name: "Isolated WBTC-AUSD WBTC",
      description:
        "A risk-isolated WBTC vault in the Euler Risk Isolated WBTC-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x52A59afAF5CB7CB09F94056fD631688D659A33B6"),
    {
      name: "Isolated WBTC-USDC WBTC",
      description:
        "A risk-isolated WBTC vault in the Euler Risk Isolated WBTC-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xF19E8Ddc541dEE2F4D6796a79b1C1E10A415a0Da"),
    {
      name: "Isolated WBTC-USDC USDC",
      description:
        "A risk-isolated USDC vault in the Euler Risk Isolated WBTC-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x88927d35e37286805f343dC449b750F431E70a20"),
    {
      name: "Isolated WBTC-USDT WBTC",
      description:
        "A risk-isolated WBTC vault in the Euler Risk Isolated WBTC-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x8f79f6EE218826D5144b917f901B147D4354Bd74"),
    {
      name: "Isolated WBTC-USDT USDT",
      description:
        "A risk-isolated USDT vault in the Euler Risk Isolated WBTC-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x870E172C3C7Ea274Ce60fB8D19D86012edc3C043"),
    {
      name: "Isolated wstETH-WETH-AUSD AUSD",
      description:
        "A risk-isolated AUSD vault in the Euler Risk Isolated wstETH-WETH-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x8c75A7177D64167E6EbC65A1D25d03CbF726fc46"),
    {
      name: "Isolated wstETH-WETH-AUSD WETH",
      description:
        "A risk-isolated WETH vault in the Euler Risk Isolated wstETH-WETH-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xb72E0659417bbB1eA55869Ab2f81cb41e751938f"),
    {
      name: "Isolated wstETH-WETH-AUSD wstETH",
      description:
        "A risk-isolated wstETH vault in the Euler Risk Isolated wstETH-WETH-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x1E4D67c666c2Ccf27A0aF980fE6c8e0f05aC8949"),
    {
      name: "Isolated wstETH-WETH-USDC USDC",
      description:
        "A risk-isolated USDC vault in the Euler Risk Isolated wstETH-WETH-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x502e4a0B61dEBA3015Eb9E51116B832003B22c2C"),
    {
      name: "Isolated wstETH-WETH-USDC WETH",
      description:
        "A risk-isolated WETH vault in the Euler Risk Isolated wstETH-WETH-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x61788859B923989dFeb995b8DE5CbBcD719475e9"),
    {
      name: "Isolated wstETH-WETH-USDC wstETH",
      description:
        "A risk-isolated wstETH vault in the Euler Risk Isolated wstETH-WETH-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x1eD6703bd9dD1a82979100D21910F17B074c8293"),
    {
      name: "Isolated wstETH-WETH-USDT wstETH",
      description:
        "A risk-isolated wstETH vault in the Euler Risk Isolated wstETH-WETH-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xf048977215c8efD805f2d48B1d45304742D6aB58"),
    {
      name: "Isolated wstETH-WETH-USDT WETH",
      description:
        "A risk-isolated WETH vault in the Euler Risk Isolated wstETH-WETH-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x57C5dfF5dDb1289c21Cc752a05330a12e3542578"),
    {
      name: "Isolated wstETH-WETH-USDT USDT",
      description:
        "A risk-isolated USDT vault in the Euler Risk Isolated wstETH-WETH-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xd2f35c39A7187BBF55c0b05C52808d7A18eD62Ca"),
    {
      name: "Isolated gMON-WMON-AUSD gMON",
      description:
        "A risk-isolated gMON vault in the Euler Risk Isolated gMON-WMON-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x94A169ad76f75E32b5E4E716A0CAcfA28a619B66"),
    {
      name: "Isolated gMON-WMON-AUSD WMON",
      description:
        "A risk-isolated WMON vault in the Euler Risk Isolated gMON-WMON-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xD5fF5152eDBD0d921bbfF5EEf84dDa95c6c5A108"),
    {
      name: "Isolated gMON-WMON-AUSD AUSD",
      description:
        "A risk-isolated AUSD vault in the Euler Risk Isolated gMON-WMON-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xb181030fF0767c24D83c65527BD42146486F415E"),
    {
      name: "Isolated gMON-WMON-USDC gMON",
      description:
        "A risk-isolated gMON vault in the Euler Risk Isolated gMON-WMON-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x5E1534Af364De6f789B67dAB52aBDC154AB48757"),
    {
      name: "Isolated gMON-WMON-USDC WMON",
      description:
        "A risk-isolated WMON vault in the Euler Risk Isolated gMON-WMON-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xF2acB868eaf64ef36BC0D3B4BA93aF00fC3167cF"),
    {
      name: "Isolated gMON-WMON-USDC USDC",
      description:
        "A risk-isolated USDC vault in the Euler Risk Isolated gMON-WMON-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x9020DbCA5a8CCfaB6116123e308204a44A5b93D4"),
    {
      name: "Isolated gMON-WMON-USDT gMON",
      description:
        "A risk-isolated gMON vault in the Euler Risk Isolated gMON-WMON-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x850DaFb683743076F65d62D95e36EC9d04FB4B23"),
    {
      name: "Isolated gMON-WMON-USDT WMON",
      description:
        "A risk-isolated WMON vault in the Euler Risk Isolated gMON-WMON-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xEe3EAEC5B3860aD40a767594f0990a74a32329e8"),
    {
      name: "Isolated gMON-WMON-USDT USDT",
      description:
        "A risk-isolated USDT vault in the Euler Risk Isolated gMON-WMON-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x6661a2b4008b70f22Ff84c2134ac6F51534E162d"),
    {
      name: "Isolated shMON-WMON-AUSD shMON",
      description:
        "A risk-isolated shMON vault in the Euler Risk Isolated shMON-WMON-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x28bD4F19C812CBF9e33A206f87125f14E65dc8aA"),
    {
      name: "Isolated shMON-WMON-AUSD WMON",
      description:
        "A risk-isolated WMON vault in the Euler Risk Isolated shMON-WMON-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x6E06ce28a6C28bffa274Ead5cb715992033E351A"),
    {
      name: "Isolated shMON-WMON-AUSD AUSD",
      description:
        "A risk-isolated AUSD vault in the Euler Risk Isolated shMON-WMON-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xb6A4db1FeF7831F65827d9aF2Cb1e69F764eC123"),
    {
      name: "Isolated shMON-WMON-USDC shMON",
      description:
        "A risk-isolated shMON vault in the Euler Risk Isolated shMON-WMON-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x7B4BcAEAC5Eb67ae947903F24BBa660eE06A5231"),
    {
      name: "Isolated shMON-WMON-USDC WMON",
      description:
        "A risk-isolated WMON vault in the Euler Risk Isolated shMON-WMON-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x3Bcc41c9510A4B601bfBfa6dA8d933d50fd175E8"),
    {
      name: "Isolated shMON-WMON-USDT shMON",
      description:
        "A risk-isolated shMON vault in the Euler Risk Isolated shMON-WMON-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x87760787d770BC9f039843fEc7636f3B8Dd12206"),
    {
      name: "Isolated shMON-WMON-USDT WMON",
      description:
        "A risk-isolated WMON vault in the Euler Risk Isolated shMON-WMON-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x2178894927657Fd5A464ce082e0b514CEb12720c"),
    {
      name: "Isolated shMON-WMON-USDT USDT",
      description:
        "A risk-isolated USDT vault in the Euler Risk Isolated shMON-WMON-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x5792753b66Eb5213E416755546abBcC1AEF1008A"),
    {
      name: "Isolated shMON-WMON-USDC USDC",
      description:
        "A risk-isolated USDC vault in the Euler Risk Isolated shMON-WMON-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xA8f093Cfb04a536Dbc6aa9BB94A2D617305a48F3"),
    {
      name: "Isolated sMON-WMON-AUSD sMON",
      description:
        "A risk-isolated sMON vault in the Euler Risk Isolated sMON-WMON-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x9eA1b948186F9A8cfe375278d96363103f4fa42B"),
    {
      name: "Isolated sMON-WMON-AUSD WMON",
      description:
        "A risk-isolated WMON vault in the Euler Risk Isolated sMON-WMON-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x3fE40329061A40f95416da42bB69E15d8eb83740"),
    {
      name: "Isolated sMON-WMON-AUSD AUSD",
      description:
        "A risk-isolated AUSD vault in the Euler Risk Isolated sMON-WMON-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xDDffd6801a86b598077aDdda04F70aF08b6f8807"),
    {
      name: "Isolated sMON-WMON-USDC sMON",
      description:
        "A risk-isolated sMON vault in the Euler Risk Isolated sMON-WMON-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x9109529c3a2EB36DE0AC3837baeA74044863C60a"),
    {
      name: "Isolated sMON-WMON-USDC WMON",
      description:
        "A risk-isolated WMON vault in the Euler Risk Isolated sMON-WMON-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x36d0f0A4cB615C200310aE2c5b5D345189d01197"),
    {
      name: "Isolated sMON-WMON-USDC USDC",
      description:
        "A risk-isolated USDC vault in the Euler Risk Isolated sMON-WMON-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x994D141557dC6abB13Afd374dDC0224C0e7eF478"),
    {
      name: "Isolated sMON-WMON-USDT sMON",
      description:
        "A risk-isolated sMON vault in the Euler Risk Isolated sMON-WMON-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xce67457A858dA99Bf19FF22d595cd60808F2E77d"),
    {
      name: "Isolated sMON-WMON-USDT WMON",
      description:
        "A risk-isolated WMON vault in the Euler Risk Isolated sMON-WMON-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x9190269F87BD30f0eB94dc3D6369b42A1A27eEfa"),
    {
      name: "Isolated sMON-WMON-USDT USDT",
      description:
        "A risk-isolated USDT vault in the Euler Risk Isolated sMON-WMON-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x1874f82AC9EF2Bd5603Cc946Cb6f3bCB9Dd2d66F"),
    {
      name: "Isolated LBTC-AUSD LBTC",
      description:
        "A risk-isolated LBTC vault in the Euler Risk Isolated LBTC-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x0709be7Bb77b25E398CcFD518770c0BAE31a38Df"),
    {
      name: "Isolated LBTC-AUSD AUSD",
      description:
        "A risk-isolated AUSD vault in the Euler Risk Isolated LBTC-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xbC5fd2cA51B0BCA8882246833B2ea8627A79bC59"),
    {
      name: "Isolated LBTC-USDC LBTC",
      description:
        "A risk-isolated LBTC vault in the Euler Risk Isolated LBTC-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xf62C7CD4f71434f7C4d12A1142133d4Ed4aBaEc4"),
    {
      name: "Isolated LBTC-USDC USDC",
      description:
        "A risk-isolated AUSD vault in the Euler Risk Isolated LBTC-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xDb53E5C7578cFB52E72728c89BA895692e49Aa45"),
    {
      name: "Isolated LBTC-USDT LBTC",
      description:
        "A risk-isolated LBTC vault in the Euler Risk Isolated LBTC-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x225e145C65031D39C3d9c58bDdAef47F8d9FaEc5"),
    {
      name: "Isolated LBTC-USDT USDT",
      description:
        "A risk-isolated AUSD vault in the Euler Risk Isolated LBTC-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x234d354b39a4Ca1274CB04972D3A9e03f1d8C4FF"),
    {
      name: "Isolated XAUT-USDT XAUT",
      description:
        "A risk-isolated XAUT vault in the Euler Risk Isolated XAUT-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x50fe3eAc875Afbf5A121F2f792fFb7F9fb27629f"),
    {
      name: "Isolated XAUT-USDT USDT",
      description:
        "A risk-isolated USDT vault in the Euler Risk Isolated XAUT-USDT market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xd505ccE10571C1d07dd40D2D9001BEf22CDF0D71"),
    {
      name: "Isolated XAUT-AUSD XAUT",
      description:
        "A risk-isolated XAUT vault in the Euler Risk Isolated XAUT-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x048e7f7857c5297Cd7623244bbb4Fae65936996a"),
    {
      name: "Isolated XAUT-AUSD AUSD",
      description:
        "A risk-isolated AUSD vault in the Euler Risk Isolated XAUT-AUSD market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x091298D908a216CfcA30729dB2B194Fe5f1d16be"),
    {
      name: "Isolated XAUT-USDC XAUT",
      description:
        "A risk-isolated XAUT vault in the Euler Risk Isolated XAUT-USDC market.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x289F801765B99B5E6263853859fE302dbecaB6d6"),
    {
      name: "Isolated XAUT-USDC USDC",
      description:
        "A risk-isolated USDC vault in the Euler Risk Isolated XAUT-USDC market.",
      entity: "euler-dao",
    },
  ],
])
